import Head from "next/head";
import { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import Router, { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { NotificationManager } from "react-notifications";
import ReactGA from "react-ga";
import { LazyLoadImage } from "react-lazy-load-image-component";
import GoogleAutoComplete from "../../components/GoogleAutocomplete";

// import { useForm } from "react-hook-form";

import Layout from "../../components/Layout";
import {
  selectedRestaurant,
  saveRestaurants,
  addToCart,
  setTotalPrice,
  // updateVariablePrice,
  setSelCity,
  setSelRes,
} from "../../store/actions/shop";
import { couponUpdated, productUpdated } from "../../store/actions/liveEvents";
import axiosInstance from "../../config/axios";
import { loader } from "../../store/actions/loader";
import InlineLoading from "../../components/UI/inlineLoader";
import { closingHourFn } from "../../helpers/closingTime";
import { deliveryClosingHourFn } from "../../helpers/deliveryClosingTime";
import useGAEventsTracker from "../../helpers/useGAEventsTracker";
import { set } from "nprogress";



function QuantitySelector({ prodId, quantity, inCart, onDelete, onQuantityChange, onCartQuantityChange }) {
  const handleDecrease = () => {
    if (inCart) {
      if (quantity <= 1) {
        onDelete();
        return;
      }
      onCartQuantityChange(prodId, quantity - 1); // update cart directly
      return;
    }
    if (quantity <= 1) return;
    onQuantityChange({ target: { value: quantity - 1 } }, prodId);
  };

  const handleIncrease = () => {
    if (inCart) {
      onCartQuantityChange(prodId, quantity + 1); // update cart directly
      return;
    }
    onQuantityChange({ target: { value: quantity + 1 } }, prodId);
  };

  return (
    <section>
      <div className="d-flex align-items-center qty-wrapper">
        <button
          type="button"
          onClick={handleDecrease}
          className="qty-btn"
          title={inCart && quantity <= 1 ? "Remove from cart" : "Decrease quantity"}
        >
          {inCart && quantity <= 1 ? (
            <i className="fa fa-trash" style={{ color: "#DC042A", fontSize: "12px" }} />
          ) : (
            <span className="qty">−</span>
          )}
        </button>

        <span style={{ minWidth: "20px", textAlign: "center", fontWeight: "600", fontSize: "14px" }}>
          {quantity}
        </span>

        <button
          type="button"
          onClick={handleIncrease}
          className="qty-btn"
          title="Increase quantity"
        >
          <span className="qty">+</span>
        </button>
      </div>
    </section>
  );
}

const Menu = ({ productCategories, couponData, time, restaurantId }) => {
  //  All Store
  const router = useRouter();
  let token = useSelector((state) => state.auth.token);
  const loggedIn = useSelector((state) => state.auth.loggedIn);

  //   restaurant name
  const restautantName = router.query;
  const [restaurantSlug, setRestaurantSlug] = useState(
    restautantName.restaurant || "",
  );

  let restautantId;

  // const restaurantName = Router.
  const dispatch = useDispatch();
  const restaurant = useSelector((state) => state.shop.selectedRestaurant);
  const allRestaurants = useSelector((state) => state.shop.allRestaurants);
  const allCart = useSelector((state) => state.shop.cart);
  const [addedToCart, setAddedToCart] = useState([]);
  // const allCart = useSelector(state => typeof state.shop.cart === 'string' ? JSON.parse(state.shop.cart) : state.shop.cart);
  const allTotalPrice = useSelector((state) => state.shop.totalPrice);
  const loadingState = useSelector((state) => state.loader.loading);
  const productIsUpdated = useSelector(
    (state) => state.liveEvent.productUpdated,
  );
  const couponIsUpdated = useSelector((state) => state.liveEvent.couponUpdated);
  const storeIsClosed = useSelector((state) => state.liveEvent.storeCloseEvent);
  const theNewRestaurant = useSelector((state) => state.shop.setNewRestaurant);
  const theSelCity = useSelector((state) => state.shop.selCityName);
  const theSelRes = useSelector((state) => state.shop.selResName);

  const [allCities, setAllCities] = useState([]);
  // const [newRestaurants, setNewRestaurants] = useState([]);
  const [restaurantCategories, setRestaurantCategories] =
    useState(productCategories);
  // const [allProductCat, setAllProductCategory] = useState(null);
  // const [products, setProducts] = useState([]);
  const [addClass, changeClass] = useState({ active: false });
  const [addVariationClass, changeVariationClass] = useState({ active: false });
  // const [activeCategory, setActiveCategory] = useState([]);
  const [productCart, setProductCart] = useState(allCart);
  const [showModal, setShowModal] = useState(false);
  const [hasCheckedLocation, setHasCheckedLocation] = useState(false);
  // const [value, setValue] = useState(0);
  const [inlineLoading, setInlineLoading] = useState(0);
  const [restaurantName, setRestaurantName] = useState(
    restautantName.restaurant,
  );
  const [selectedCityName, setSelectedCityName] = useState(null);
  const [selectedVariableProducts, setSelectedVariableProducts] = useState([]);
  const [quantitiesArray, setQuantitiesArray] = useState([]);
  const [categoryActiveName, setCategoryActiveName] = useState("");
  const [disableScrollEvent, setDisableScrollEvent] = useState(false);
  const [varId, setVarId] = useState({});
  const [closedHour, setClosedHour] = useState("");
  const [minOrderAmount, setMinOrderAmount] = useState(null);
  const [resId, setResId] = useState(restaurantId);
  const [couponListData, setCouponListData] = useState(couponData);

  const [searchvalue, setSearchValue] = useState("");
  const [dbValue, saveToDb] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [allProductList, setAllProductList] = useState([]);
  const [place, setPlace] = useState("");
  const [selectedRestaurantName, setSelectedRestaurantName] = useState("");
  const [orderType, setOrderType] = useState(null);
  const [deliverytracer, setDeliveryTracer] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [houseNumber, setHouseNumber] = useState("");
  const [locationSelected, setLocationSelected] = useState(false);
  const [newLocation, setNewLocation] = useState(null);
  const [status, setStatus] = useState("");
  const [id, setId] = useState(null);
  const [calculateDistance, setCalculateDistance] = useState(false);
  const [restaurantClosest, setRestaurantClosest] = useState({});
  const [restaurants, setRestaurants] = useState([]);
  const [emptyRes, setEmptyRes] = useState(false);
  const [restaurantStatus, setRestaurantStatus] = useState(null);
  const [restaurantDeleted, setRestaurantDeleted] = useState(null);
  const [showCartVisibility, setShowCartVisibility] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [pickupActive, setPickupActive] = useState(null);
  const [deliveryActive, setDeliveryActive] = useState(null);
  const [locationPicker, setLocationPicker] = useState(false)
  const [openingTime, setOpeningTime] = useState ("")
  const [closingTime, setClosingTime] = useState("")
  const [deliveryOpeningTime, setDeliveryOpeningTime] = useState("")
  const [deliveryClosingTime, setDeliveryClosingTime] = useState("")
  const [deliveryClosed, setDeliveryClosed] = useState(null)
  const [pickupClosed, setPickupClosed] = useState(null)
 
  

  const canonicalUrl = `https://kilimanjaro-restaurants.com/menu/${router.query.restaurant || ''}`;

 

  const GAEventsTracker = useGAEventsTracker("Menu Page");

  const mappedCities = Array.isArray(allCities)
    ? allCities?.map((city) => ({
        value: city?.id,
        label: city?.city,
      }))
    : [];
    const handleCartQuantityChange = (prodId, newQty) => {
  const cartCopy = [...allCart];
  const cartIndex = cartCopy.findIndex((item) => item.product.id === prodId);

  if (cartIndex === -1) return;

  const cartItem = cartCopy[cartIndex];
  const price = cartItem.salePrice || cartItem.price;

  cartCopy[cartIndex] = {
    ...cartItem,
    quantity: newQty,
    totalPrice: newQty * price,
  };

  // also sync local quantity selector
  setQuantitiesArray((prev) => {
    const index = prev.findIndex((x) => x.productId === prodId);
    if (index !== -1) {
      const updated = [...prev];
      updated[index] = { productId: prodId, quantity: newQty };
      return updated;
    }
    return prev;
  });

  setProductCart(cartCopy);
  dispatch(addToCart(cartCopy));
  dispatch(setTotalPrice());
};

  const getCities = async () => {
    try {
      const {
        data: { data },
      } = await axiosInstance.get("cities");

      setAllCities(data);
      // getRestaurantName(data)
    } catch (err) {}
  };
  const toggleCart = () => {
    setShowCart((prev) => !prev);
  };
  useEffect(() => {
    const handleScroll = () => {
      // Check if user scrolled down (e.g. more than 100px)
      if (window.scrollY > 100) {
        setShowCartVisibility(true);
      } else {
        setShowCartVisibility(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const updateQuantityHandle = (cartIndex, action) => {
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;

    // increment or decrement
    if (action === "increment") {
      cartCopy[cartIndex].quantity += 1;
    } else if (action === "decrement" && cartCopy[cartIndex].quantity > 1) {
      cartCopy[cartIndex].quantity -= 1;
    }

    // recalculate total
    cartCopy[cartIndex].totalPrice = cartCopy[cartIndex].quantity * price;

    // update state + redux
    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
  };
  const totalSum = allCart.reduce((sum, item) => sum + item.totalPrice, 0);
  useEffect(() => {
    getRestaurantName(allCities);
  }, [allCities]);

  const getRestaurantName = (cities) => {
    if (!Array.isArray(cities)) return;

    cities.map((c) => {
      c?.restaurants?.map((r) => {
        if (r.slug === restautantName.restaurant) {
          const val = {
            value: c?.id,
            label: c?.city,
          };
          setRestaurantName(r);
          setSelectedCityName(val);
          dispatch(setSelCity(val));
          dispatch(saveRestaurants(c.restaurants));
          dispatch(selectedRestaurant(r));
          dispatch(setSelRes(r));
          Cookies.set("setRestaurants", JSON.stringify(c.restaurants));
          Cookies.set("cityFocused", JSON.stringify(val));
        }
      });
    });
  };

  useEffect(() => {
    const cities = localStorage.getItem("setAllCities")
      ? JSON.parse(localStorage.getItem("setAllCities"))
      : [];
    cities?.length === 0 ? getCities() : null;
  }, [router]);

  useEffect(() => {
    const newRestaurant = allRestaurants?.filter(
      (res) => res.slug === restautantName.restaurant,
    )[0];
    setRestaurantName(newRestaurant);
  }, []);


//   useEffect(() => {
//   const navigationSource = sessionStorage.getItem("navigationSource");

//   if (navigationSource === "internal") {
//     // clear it so the next visit from outside the app works correctly
//     sessionStorage.removeItem("navigationSource");
//     return;
//   }

//   const triggerModal = () => {
//     if (typeof window.$ !== "undefined" && typeof window.$.fn.modal !== "undefined") {
//       window.$("#orderTypeModal").modal("show");
//     } else {
//       setTimeout(triggerModal, 100);
//     }
//   };

//   triggerModal();
// }, []);

  useEffect(() => {
    (async () => {
      if (!restaurantSlug) return;
      let response = await axiosInstance.get(
        `V1/restaurants/${restaurantSlug}/products`,
      );

      if (response.status === 200) {
        restautantId = response.data.data[0].restaurant_id;
        const resStatus = response.data.restaurant.active;
        const resDeleted = response.data.restaurant.deleted;
        const deliveryActive = response.data.restaurant.delivery_active;
        const pickupActive = response.data.restaurant.pickup_active;

        setId(restautantId);
        setRestaurantStatus(resStatus);
        setRestaurantDeleted(resDeleted);
        setDeliveryActive(deliveryActive);
        setPickupActive(pickupActive);
        setSelectedRestaurantName(response.data.restaurant.name);
         const convertTo12Hour = (time) => {
          const [hour, minute] = time.split(":");
          const h = parseInt(hour, 10);
          const ampm = h >= 12 ? "PM" : "AM";
          const formattedHour = h % 12 || 12; // converts "00" → "12"
          return `${formattedHour}:${minute}${ampm}`;
        };
       const checkStoreHours = (openingTime24, closingTime24) => {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const [openHour, openMin] = openingTime24.split(":").map(Number);
  const [closeHour, closeMin] = closingTime24.split(":").map(Number);

  const openingMinutes = openHour * 60 + openMin;
  const closingMinutes = closeHour * 60 + closeMin;

  if (closingMinutes < openingMinutes) {
    return currentMinutes < openingMinutes && currentMinutes >= closingMinutes;
  }

  return currentMinutes < openingMinutes || currentMinutes >= closingMinutes;
};
const rawOpeningTime = response.data.restaurant.opening_time; 
const rawClosingTime = response.data.restaurant.closing_time;
const rawDeliveryOpeningTime = response.data.restaurant.delivery_opening_time;
const rawDeliveryClosingTime = response.data.restaurant.delivery_closing_time;
        const openingTime = convertTo12Hour(rawOpeningTime)
        const closingTime = convertTo12Hour(rawClosingTime)
        const deliveryOpeningTime = convertTo12Hour(rawDeliveryOpeningTime);
        const deliveryClosingTime = convertTo12Hour(rawDeliveryClosingTime);
      
        setOpeningTime(openingTime)
        setClosingTime(closingTime)
        setDeliveryOpeningTime(deliveryOpeningTime)
        setDeliveryClosingTime(deliveryClosingTime)

        const storedDeliveryType = localStorage.getItem("Deliverytype");
const currentOrderType = JSON.parse(storedDeliveryType);
const checkDeliveryClosed = checkStoreHours(rawDeliveryOpeningTime, rawDeliveryClosingTime);
const checkPickupClosed = checkStoreHours(rawOpeningTime, rawClosingTime);
setDeliveryClosed(checkDeliveryClosed)
setPickupClosed(checkPickupClosed)
        
let isClosed = false;

if (currentOrderType === "delivery") {
  // check delivery hours if delivery times exist, fallback to pickup hours
  if (rawDeliveryOpeningTime && rawDeliveryClosingTime) {
    isClosed = checkStoreHours(rawDeliveryOpeningTime, rawDeliveryClosingTime);
    
    

  } else {
    isClosed = checkStoreHours(rawOpeningTime, rawClosingTime);
  }
} else {
  // pickup hours
  isClosed = checkStoreHours(rawOpeningTime, rawClosingTime);
  
  
}


const navigationSource = sessionStorage.getItem("navigationSource");

  if (navigationSource === "internal") {
    // clear it so the next visit from outside the app works correctly
    sessionStorage.removeItem("navigationSource");
    return;
  }

  const triggerModal = () => {
    if (typeof window.$ !== "undefined" && typeof window.$.fn.modal !== "undefined") {
      window.$("#orderTypeModal").modal("show");
    } else {
      setTimeout(triggerModal, 100);
    }
  };
  

  if(!isClosed && navigationSource === null){
    triggerModal();
    
    

  }
  



if (isClosed) {
  setTimeout(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.$ !== "undefined" &&
      typeof window.$.fn.modal !== "undefined"
    ) {
      window.$("#storeIsClosed").modal("show");


      
    } else {
      document.getElementById("closed-store-modal")?.click();
      
      
     
    }
  }, 3000);
}
     

        const {
          data: { data },
        } = await axiosInstance.get(
          `product-categories?restaurant_id=${restautantId}`,
        );

        const productCategories = data
          .filter((cat) => cat.category_products.length > 0)
          .map((prodCat) => {
            prodCat["category_products"] = prodCat.category_products.map(
              (catProd) => {
                if (catProd.product_type === "variable") {
                  catProd["product_variations"] =
                    catProd.product_variations?.map((pVar) => {
                      const decodedVariations = JSON.parse(pVar.variations);
                      // Convert to array if decodedVariations is not already an array
                      const variationsArray = Array.isArray(decodedVariations)
                        ? decodedVariations
                        : [decodedVariations];

                      pVar["decodedVariations"] = variationsArray
                        .map((variation, index) => ({
                          ...variation,
                          status: pVar.variations_statuses[index],
                        }))
                        .filter((variation) => variation.status);
                      return pVar;
                    });

                  return catProd;
                }
                return catProd;
              },
            );

            return prodCat;
          });
        setRestaurantCategories(productCategories);
      }
    })();
  }, [restaurantSlug, openingTime]);

  

  // Search product list
  const handleSearch = async (event) => {
    const { value: nextValue } = event.target;
    setSearchValue(nextValue);
    try {
      // // highlight-starts
      if (nextValue.length > 2) {
        
        const response = allProductList.filter((x) =>
          x.product.toLowerCase().includes(nextValue.toLowerCase()),
        );
        if (nextValue.length > 2) {
          setShowSearchBar(true);
          saveToDb(response);
          
        } else {
          setShowSearchBar(false);
          saveToDb([]);
          
        }
        
      } else {
        setShowSearchBar(false);
        saveToDb([]);
        
      }
      // highlight-ends
    } catch (e) {
      setShowSearchBar(false);
      saveToDb([]);
    }
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    const prodList = [];
    restaurantCategories?.forEach((restCat) => {
      restCat.category_products?.forEach((prod) => prodList.push(prod));
    });
    setAllProductList(prodList);
  }, []);

  useEffect(() => {
    if (restaurantCategories) {
      setCategoryActiveName(restaurantCategories[0]?.category);
    }
  }, [restaurantCategories]);

  useEffect(() => {
    const selCityName = theSelCity;
    const selResName = theSelRes;
    setSelectedCityName(selCityName);
    setRestaurantName({ ...selResName, name: selResName?.label, active: 1 });
    // setRestaurantName(restautantName.restaurant);
  }, []);

  useEffect(() => {
    const fetchProductCategories = async () => {
      try {
        dispatch(loader());
        setInlineLoading(1);
        const {
          data: { data },
        } = await axiosInstance.get(
          `product-categories?restaurant_id=${resId}`,
        );
        const productCategories = data
          .filter((cat) => cat.category_products.length > 0)
          .map((prodCat) => {
            prodCat["category_products"] = prodCat.category_products.map(
              (catProd) => {
                if (catProd.product_type === "variable") {
                  catProd["product_variations"] =
                    catProd.product_variations?.map((pVar) => {
                      const decodedVariations = JSON.parse(pVar.variations);
                      pVar["decodedVariations"] = decodedVariations
                        .map((variation, index) => ({
                          ...variation,
                          status: pVar.variations_statuses[index],
                        }))
                        .filter((variation) => variation.status);
                      return pVar;
                    });

                  return catProd;
                }
                return catProd;
              },
            );

            return prodCat;
          });
        setRestaurantCategories(productCategories);
        dispatch(loader());
        setInlineLoading(0);
      } catch (error) {
        dispatch(loader());
        setInlineLoading(0);
      }
    };

    if (productIsUpdated) {
      fetchProductCategories();
    }
  }, [productIsUpdated]);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        dispatch(loader());
        setInlineLoading(1);
        const {
          data: { data },
        } = await axiosInstance.get(`product-coupons?restaurant_id=${resId}`);
        setCouponListData(data);
        dispatch(loader());
        setInlineLoading(0);
        
      } catch (error) {
        dispatch(loader());
        setInlineLoading(0);
      }
    };

    if (couponIsUpdated) {
      fetchCoupon();
    }
  }, [couponIsUpdated]);

  // useEffect(() => {
  //   if (storeIsClosed) {
  //     $("#storeClosed").modal("show");
  //     return;
  //   }
  // }, [storeIsClosed]);

  useEffect(() => {
    const fetchMinPrice = async () => {
      try {
        const {
          data: { data: res },
        } = await axiosInstance.get("settings/get-min-order-amount");
        setMinOrderAmount(+res.min_order_amount);
      } catch (e) {}
    };
    fetchMinPrice();
  }, []);

  useEffect(() => {
    const orderTimeState = closingHourFn(time);
    const deliveryOrderTimeState = deliveryClosingHourFn(time);

    if (orderTimeState) {
      Cookies.set("closed", false);
    } else {
      Cookies.set("closed", true);
    }

    const closedTime = Cookies.get("closed");
    setClosedHour(closedTime);
  }, [time, setClosedHour]);

  useEffect(() => {
    const cities = localStorage.getItem("setAllCities")
      ? JSON.parse(localStorage.getItem("setAllCities"))
      : [];
    setAllCities(cities);
    Cookies.remove("variable");
  }, []);

  useEffect(() => {
  if (process.browser && !disableScrollEvent) {
    let headers = document.querySelectorAll(".category-header");
    window.addEventListener("scroll", () => {
      Array.from(headers)?.forEach((header) => {
        const itemHeight = header.getBoundingClientRect().top;
        if (itemHeight <= 189.54 && itemHeight > 100) {
          setCategoryActiveName(header.id);
        }
      });
    });
  }

  // ← wait for jQuery before running jQuery-dependent code
  const waitForJQuery = (callback) => {
    if (typeof window.jQuery !== "undefined") {
      callback(window.jQuery);
    } else {
      setTimeout(() => waitForJQuery(callback), 100);
    }
  };

  waitForJQuery(($) => {
    var elements = $(".category-single");

    for (var i = 0, len = elements.length; i < len; i++) {
      elements[i].addEventListener("click", function () {
        var firstEl = $(this).find("a")[0];
        firstEl.addEventListener("click", function (e) {
          e.preventDefault();
        });
        $(this).find(".subcats").slideToggle();
      });
    }
  });
}, []);

  useEffect(() => {
    if (restaurantCategories?.length > 0) {
      // Set the default quantities for all products
      let products = [];
      restaurantCategories?.forEach((c) => {
        const productsArray = c.category_products;

        productsArray?.forEach((x) => {
          products.push(x);
        });
      });

      setQuantitiesArray(
        products.map((p) => ({ productId: p.id, quantity: 1 })),
      );

    }
  }, [restaurantCategories]);

  useEffect(() => {
    const restaurant = Cookies.get("selectedRestaurant");
    const selectRestaurant = restaurant ? JSON.parse(restaurant) : null;
    

    if (!restaurant) {
      dispatch(selectedRestaurant(selectRestaurant));
    }

    if (!allRestaurants?.length > 0) {
      dispatch(saveRestaurants(theNewRestaurant));
    }
  }, []);

  // Scroll to the top on page load
  useEffect(() => {
    if (typeof window !== "undefined" && typeof $ !== "undefined"){
      window.$ = $;
    $(window).ready(function () {
      const $el = $("html, body");
      $el.css({ "overflow-x": "unset" });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });

    }
    
  }, []);

  useEffect(() => {
    if ($(window).width() > 768) {
      $(window).scroll(function (e) {
        const $el = $("#category-top");
        const $el2 = $(".button-float");
        const isPositionFixed = $el.css("position") === "sticky";
        if ($(this).scrollTop() > 140 && !isPositionFixed) {
          $el.css({ position: "sticky", top: "0" });
          $el2.css({ display: "block" });
        }
        if ($(this).scrollTop() < 140 && isPositionFixed) {
          $el.css({ position: "static", top: "0" });
          $el2.css({ display: "none" });
        }
      });
    }
    $(window).scroll(function (e) {
      const $el2 = $(".button-float");
      if ($(this).scrollTop() > 140) {
        $el2.css({ display: "block" });
      }
      if ($(this).scrollTop() < 140) {
        $el2.css({ display: "none" });
      }
    });
  }, []);

  const toggleActiveClass = () => {
    changeClass({
      active: !addClass.active,
    });
  };

  let cartClasses = ["cart"];

  if (addClass.active) {
    cartClasses.push("active-cart");
  }
  
  const categoryListHandler = (categoryName) => {
    setDisableScrollEvent(true);
    setTimeout(() => setCategoryActiveName(categoryName), 500);

    const headers = document.getElementById(categoryName);

    if (!headers) {
      console.warn(`Element with ID '${categoryName}' not found.`);
      setDisableScrollEvent(false); // ensure we re-enable scroll
      return;
    }

    const itemHeight = headers.offsetTop;

    window.scroll({
      top: itemHeight,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => setDisableScrollEvent(false), 500);
  };

  const handleMenuRestaurantCItyChange = (val) => {
    dispatch(loader());
    let newRestaurants = allCities.find(
      (city) => city.id === val.value,
    ).restaurants;
    newRestaurants = newRestaurants.map((restaurant) => ({
      ...restaurant,
      value: restaurant.city_id,
      label: restaurant.name,
    }));
    setRestaurantName(null);
    // setNewRestaurants(newRestaurants);
    setSelectedCityName(val);
    dispatch(setSelCity(val));
    dispatch(saveRestaurants(newRestaurants));
    Cookies.set("setRestaurants", JSON.stringify(newRestaurants));
    Cookies.set("cityFocused", JSON.stringify(val));
    setTimeout(() => {
      dispatch(loader());
    }, 1500);
  };

  const [text, setText] = useState("");
  const handleMenuRestaurantInputChange = async (value) => {
    if (!value.active) {
      setText("This store is currently unavailable for deliveries");
      document.getElementById("inactive-modal").click();
      return;
    }
    const formattedRestaurant = value?.label
      ?.split(" ")
      .join("-")
      .replace(",", "")
      .toLowerCase();

    Router.push(`/menu/${value.slug}`);

    Cookies.set("totalPrice", 0);
    dispatch(addToCart([]));
    setProductCart([]);
    setRestaurantName(value);
    dispatch(selectedRestaurant(value));
    dispatch(setSelRes(value));
    try {
      dispatch(loader());
      const {
        data: { data },
      } = await axiosInstance.get(
        `product-categories?restaurant_id=${value.id}`,
      );
      const {
        data: { data: couponData },
      } = await axiosInstance.get(`product-coupons?restaurant_id=${value.id}`);
      setCouponListData(couponData);
      const productCategories = data
        .filter((cat) => cat.category_products.length > 0)
        .map((prodCat) => {
          prodCat["category_products"] = prodCat.category_products.map(
            (catProd) => {
              if (catProd.product_type === "variable") {
                catProd["product_variations"] = catProd.product_variations?.map(
                  (pVar) => {
                    const decodedVariations = JSON.parse(pVar.variations);
                    pVar["decodedVariations"] = decodedVariations
                      .map((variation, index) => ({
                        ...variation,
                        status: pVar.variations_statuses[index],
                      }))
                      .filter((variation) => variation.status);
                    return pVar;
                  },
                );

                return catProd;
              }
              return catProd;
            },
          );

          return prodCat;
        });

      if (productCategories.length > 0) {
        
      }
      setRestaurantCategories(productCategories);
      dispatch(loader());
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      setTimeout(
        () => setCategoryActiveName(productCategories[0]?.category),
        500,
      );
      setResId(value.id);
    } catch (error) {
      dispatch(loader());
    }
    const selectedRes = {
      label: value?.label,
      value: value.id,
    };
    Cookies.set("resFocused", JSON.stringify(selectedRes));
    Cookies.set("selectedRestaurant", JSON.stringify(value));
    // setValue((value) => ++value);
  };
const handleQuantityChange = (e, prodId) => {
  const newQty = +e.target.value;

  setQuantitiesArray((prev) => {
    const index = prev.findIndex((x) => x.productId === prodId);

    if (index !== -1) {
      // replace the entry at that index with a new object
      const updated = [...prev];
      updated[index] = { productId: prodId, quantity: newQty };
      return updated;
    } else {
      // product not yet in array, add it
      return [...prev, { productId: prodId, quantity: newQty }];
    }
  });
};
  // const handleQuantityChange = (e, prodId) => {
  //   const prevProdQtyIndex = quantitiesArray.findIndex(
  //     (x) => x.productId === prodId,
  //   );
  //   const prevProdQty = quantitiesArray[prevProdQtyIndex];

  //   if (prevProdQty) {
  //     quantitiesArray[prevProdQtyIndex] = {
  //       productId: prodId,
  //       quantity: +e.target.value,
  //     };
  //   } else {
  //     const newQuantityArray = { productId: prodId, quantity: +e.target.value };
  //     quantitiesArray.push(newQuantityArray);
  //   }

  //   setQuantitiesArray(quantitiesArray);
  // };
  const isInCart = (productId) =>
    allCart.some((item) => item.product.id === productId);

  const addtoCartHandler = (prod) => {
    GAEventsTracker("Added to cart", `Product Name: ${prod.product}`);
    setInlineLoading(prod.id);
    dispatch(loader());
    const prevCart = [...allCart];

    const quantitySelected = quantitiesArray.find(
      (q) => q.productId === prod.id,
    ).quantity;

    /** This is an example of checking if a product is in cart and updating it */
    const prodInCartIndex = prevCart.findIndex(
      (cart) => cart.product.id === prod.id,
    );

    const productType = prod.product_type;

    if (prodInCartIndex >= 0) {
      const prodInCart = prevCart[prodInCartIndex];

      if (productType === "variable") {
        const productVariation = selectedVariableProducts.find(
          (x) =>
            x.productId === prod.id &&
            x.product_variation == varId.product_variation,
        );
        const similarVariableProductInCartIndex = prevCart.findIndex(
          (cart) =>
            cart.product.id === prod.id &&
            cart.product_variation === productVariation.product_variation,
        );

        //  Checks if the selected variable product exists in the prev cart
        if (similarVariableProductInCartIndex !== -1) {
          prevCart[similarVariableProductInCartIndex] = {
            product: prod,
            ...productVariation,
            quantity:
              +prevCart[similarVariableProductInCartIndex].quantity +
              parseInt(quantitySelected),
            salePrice: productVariation.salePrice || productVariation.price,
            totalPrice:
              +prevCart[similarVariableProductInCartIndex].totalPrice +
              (productVariation.salePrice || productVariation.price) *
                parseInt(quantitySelected),
          };
        } else {
          productVariation.salePrice = productVariation.salePrice || null;
          const newCart = {
            ...productVariation,
            quantity: quantitySelected,
            totalPrice:
              quantitySelected *
              (productVariation.salePrice || productVariation.price),
          };
          prevCart.push(newCart);
        }
      } else {
        const newTotalPrice = prod.sale_price
          ? +quantitySelected * parseInt(prod.sale_price)
          : +quantitySelected * parseInt(prod.price);
        prevCart[prodInCartIndex] = {
          product: prod,
          quantity: +prodInCart.quantity + parseInt(quantitySelected),
          price: parseInt(prod.price),
          salePrice: prodInCart.salePrice
            ? +prodInCart.salePrice + parseInt(prod.sale_price)
            : null,
          totalPrice: +prodInCart.totalPrice + newTotalPrice,
        };
      }
    } else {
      if (productType === "variable") {
        const productVariation = selectedVariableProducts.find(
          (x) => x.productId === prod.id,
        );
        productVariation.salePrice = productVariation.salePrice || null;
        const newCart = {
          ...productVariation,
          quantity: quantitySelected,
          totalPrice:
            quantitySelected *
            (productVariation.salePrice || productVariation.price),
        };
        prevCart.push(newCart);
      } else {
        prevCart.push({
          product: prod,
          quantity: parseInt(quantitySelected),
          price: parseInt(prod.price),
          salePrice: parseInt(prod.sale_price),
          totalPrice: prod.sale_price
            ? quantitySelected * parseInt(prod.sale_price)
            : quantitySelected * parseInt(prod.price),
        });
      }
    }
    setProductCart(prevCart);
    dispatch(addToCart(prevCart));
    dispatch(setTotalPrice());
    setTimeout(() => {
      dispatch(loader());
    }, 1500);
    setTimeout(() => {
      // setAddedToCart((prev) => [...prev, prod.id]);
      setInlineLoading(0);
    }, 1500);
    setTimeout(() => {
      NotificationManager.success("Added to cart successfully", "", 3000);
    }, 1500);
    // setValue((value) => ++value);
  };

  const deleteProductCartHandler = (index, id) => {
    const cartSlice = [...allCart];
    cartSlice.splice(index, 1);
    setProductCart(cartSlice);
    dispatch(addToCart(cartSlice));
    dispatch(setTotalPrice());
  };

  let cartDisplay = <p>Your cart is currently empty</p>;
  const formattedCart = allCart.map((item) => ({
    product_cost: item.price,
    quantity: item.quantity,
    product_id: item.productId ? item.productId : item.product.id,
    subTotal: item.totalPrice,
    variation: item.product_variation ? item.product_variation : null,
  }));

  const updateCart = async () => {
    if (loggedIn && formattedCart.length > 0) {
      const cartData = localStorage.getItem("cart_abandonement_data");

      const parsedData = JSON.parse(cartData || "{}");

      const cartPayload = {
        restaurant_id: parsedData.restaurant_id,
        order_type: parsedData.order_type,
        delivery_address: parsedData.delivery_address,
        latitude: parsedData.latitude,
        longitude: parsedData.longitude,
        delivery_tracer: parsedData.delivery_tracer,
        cart_items: formattedCart,
      };

      try {
        const response = await axiosInstance.post("V1/cart", cartPayload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    updateCart();
  }, [allCart]);

  

  // useEffect(() => {
  //   // Check navigation type using performance API
  //   const navigationEntries = performance.getEntriesByType("navigation");
  //   const navigationType =
  //     navigationEntries[0]?.type || performance.navigation?.type;

  //   const isPageReload = navigationType === "reload" || navigationType === 1;
  //   const navigationSource = sessionStorage.getItem("navigationSource");

  //   if (navigationSource === "internal" && !isPageReload) {
  //     sessionStorage.removeItem("navigationSource"); // Clear the flag
  //     // Handle internal navigation logic (no modal)
  //   } else {
  //     console.log(
  //       "User landed directly (e.g., via search engine, pasted URL, or reload)",
  //     );
  //     const orderTypeButton = document.getElementById("order-type-modal");
  //     if (orderTypeButton && !isPageReload) {
  //       orderTypeButton.click(); // Show modal only for direct navigation
  //     }
  //     // Handle direct access logic
  //     sessionStorage.removeItem("navigationSource"); // Clear flag for safety
  //   }
  // }, []);
  const handleOrderTypeChange = (e) => {
    const selectedValue = e.target.value;

    setOrderType(selectedValue);
    setLocationPicker(true)
    localStorage.setItem("Deliverytype", JSON.stringify(selectedValue));

    // if (selectedValue === "pickup") {
    //   $("#closeOrderTypeModal").click();
    // }
  };

  const handleRestaurantInputChange = useCallback((value) => {
    if (orderType === "'delivery'" || "'pickup'") {
      if (!value?.active) {
        document.getElementById("inactive-modal").click();
        return;
      }

      // setInlineLoad(1);
      Cookies.remove("totalPrice");
      Cookies.remove("setCart");
      Cookies.remove("orderItem");
      localStorage.removeItem("checkoutToLogin");

      dispatch(selectedRestaurant(value));
      Cookies.set("selectedRestaurant", JSON.stringify(value));

      const selectedRes = {
        label: value.label,
        value: value.id,
      };

      dispatch(setSelRes(selectedRes));
      setRestaurantName(value);
      setRestaurantSlug(value.slug);

      window.history.replaceState(null, "", `/menu/${value.slug}`);

      $("#closeModal").click();
    } else {
      setShowModal(true);
    }
  });
  const closeModal = () => {
    $("#closeModal").click();

  }

  const handlePlaceSelect = (place) => {
    const latitude = place.location.latitude;
    const longitude = place.location.longitude;

    setLatitude(latitude);
    setLongitude(longitude);

    const formatted = place.formattedAddress;
    setNewLocation(formatted); // still set it if needed elsewhere
    setLocationSelected(true);

    // Optional: house number logic
    const houseNumberPattern = /^\d+/;
    const match = formatted.match(houseNumberPattern);
    const trimmedAddress = match ? match[0].trim() : null;
    if (trimmedAddress) setHouseNumber(trimmedAddress);

    localStorage.setItem("selectedPlace", JSON.stringify(formatted));

    const addressData = {
      address: formatted,
      lat: latitude,
      long: longitude,
      house_number: trimmedAddress,
    };
    localStorage.setItem("addressData", JSON.stringify(addressData));

    // ✅ Pass formatted directly
    verifyDeliveryDistance(latitude, longitude, formatted);
  };
  const searchOrderingCity = async (latitude, longitude, orderType) => {
    try {
      const response = await axiosInstance.get(
        `V1/restaurants/v2/near-me?latitude=${latitude}&longitude=${longitude}&count=10&page=1&type=${orderType}`,
      );

      const orderState = response.data;

      if (
        orderState.data.statusCode >= 200 &&
        orderState.data.statusCode < 300
      ) {
        const otherRestaurants = orderState.data.data.other_restaurants;
        const nearbyRestaurant = orderState.data.data.restaurant.restaurant;

        // .data.data.other_restaurants
        setRestaurants(otherRestaurants);

        const deliveryTracer = orderState.data.data.delivery_tracer;
        setDeliveryTracer(deliveryTracer);
        setRestaurantClosest(nearbyRestaurant);
        const cartAbandonementData = {
          restaurant_id: nearbyRestaurant.id,
          order_type: orderType,
          delivery_address: nearbyRestaurant.address,
          latitude: nearbyRestaurant.latitude,
          longitude: nearbyRestaurant.longitude,
          delivery_tracer: orderState.data.data.delivery_tracer,
        };
        localStorage.setItem(
          "cart_abandonement_data",
          JSON.stringify(cartAbandonementData),
        );
        const defaultAddressData = {
          restaurant_id: nearbyRestaurant.id,
          order_type: orderType,
          delivery_address: nearbyRestaurant.address,
          latitude: nearbyRestaurant.latitude,
          longitude: nearbyRestaurant.longitude,
          delivery_tracer: orderState.data.data.delivery_tracer,
        };
        localStorage.setItem(
          "default_address_data",
          JSON.stringify(defaultAddressData),
        );
        localStorage.setItem("delivery_tracer", deliveryTracer);
        localStorage.setItem(
          "cached closest_restaurant",
          JSON.stringify(nearbyRestaurant),
        );
        localStorage.setItem(
          "cached other_restaurant",
          JSON.stringify(otherRestaurants),
        );
        localStorage.setItem(
          "delivery price",
          orderState.data.data.restaurant.restaurant.delivery_price,
        );
      }
      // Update restaurants with only the first 2 items in the array
      else if (
        orderState.data.statusCode === 500 ||
        orderState.data.status === 500
      ) {
        localStorage.removeItem("cached closest_restaurant");
        localStorage.removeItem("cached other_restaurant");
        localStorage.removeItem("delivery price");
        localStorage.removeItem("delivery_tracer");

        setEmptyRes(true);
      }
    } catch (error) {
      localStorage.removeItem("cached closest_restaurant");
      localStorage.removeItem("cached other_restaurant");
      localStorage.removeItem("delivery price");
      localStorage.removeItem("delivery_tracer");

      setEmptyRes(true);

      console.error("Error fetching nearby restaurants:", error);
    }
  };

  const verifyDeliveryDistance = async (lat, lng, locationLabel) => {
    // Safeguard: Ensure lat and lng are valid
    if (!lat || !lng) {
      setCalculateDistance(false);
      setStatus("out of range"); // Or handle as needed
      return;
    }

    const payload = {
      restaurant_id: id,
      latitude: lat?.toString(),
      longitude: lng?.toString(),
    };

    setCalculateDistance(true);

    try {
      const response = await axiosInstance.post(
        "V1/calculate-delivery-charge",
        payload,
      );

      if (response.status === 200) {
        const resultStatus = response.data?.data?.status;

        if (resultStatus === "within range") {
          setStatus("within range");
          setPlace(locationLabel);
        } else {
          setStatus("out of range");
          setPlace(locationLabel);
          await searchOrderingCity(lat, lng, orderType);
        }
      } else {
        setStatus("out of range");
        setPlace(locationLabel);
        await searchOrderingCity(lat, lng, orderType);
      }
    } catch (error) {
      console.log(error);
      setStatus("out of range");
      setPlace(locationLabel);
      await searchOrderingCity(lat, lng, orderType);
    } finally {
      setCalculateDistance(false);
    }
  };
  const handleButtonClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;

            // Convert coordinates to strings for the payload
            const latStr = latitude.toString();
            const lngStr = longitude.toString();

            // Set state for latitude and longitude
            setLatitude(latStr);
            setLongitude(lngStr);
            setLocationSelected(true);

            // Fetch geolocation data to get formatted address
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_OPENCAGE_API_KEY}`,
            );

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const formattedAddress =
              data.results[0]?.formatted_address || "Unknown Location";

            // Set formatted address

            setNewLocation(formattedAddress);

            // Extract house number (if any)
            const houseNumberPattern = /^\d+/;
            const match = formattedAddress.match(houseNumberPattern);
            const trimmedAddress = match ? match[0].trim() : null;
            if (trimmedAddress) {
              setHouseNumber(trimmedAddress);
            }

            // Store address data in localStorage
            const addressData = {
              address: formattedAddress,
              lat: latStr,
              long: lngStr,
              house_number: trimmedAddress,
              //delivery_tracer: deliverytracer,
              //order_type: deliveryType,
            };
            localStorage.setItem("addressData", JSON.stringify(addressData));
            localStorage.setItem(
              "selectedPlace",
              JSON.stringify(formattedAddress),
            );

            // Call verifyDeliveryDistance with the coordinates and formatted address
            verifyDeliveryDistance(latitude, longitude, formattedAddress);
          } catch (error) {
            console.error("Error processing location:", error);
            setStatus("out of range");
            setCalculateDistance(false);
          } finally {
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          setStatus("out of range");
          setCalculateDistance(false);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setStatus("out of range");
      setCalculateDistance(false);
    }
  };

  if (allCart.length > 0) {
    cartDisplay = (
      <>
        {(allCart ?? []).map((cart, index) => {
          let productName = "";
          if (cart.product_variation) {
            productName = (
              <p>
                {cart.product.product} ({cart.product_variation})
              </p>
            );
          } else {
            productName = <p>{cart.product.product}</p>;
          }
          return (
            <>
              <div
                key={`Prod-cart${cart?.product.id || index}`}
                className="product-list"
              >
                <div className="row text-md-left text-center">
                  <div className="col-md-3">
                    <img
                      className="img-fluid"
                      src={cart.product.image_url}
                      alt=""
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="align-items-center justify-content-around flex-wrap">
                      {productName}
                    </div>
                    <p className="bold">
                      {"₦" + cart?.totalPrice?.toLocaleString()}
                    </p>
                    <input
                      onChange={(e) => updateQuantityChangeHandle(e, index)}
                      type="number"
                      value={cart.quantity}
                      defaultValue={cart.quantity}
                      min={"1"}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      onClick={() =>
                        deleteProductCartHandler(index, cart.product.id)
                      }
                    >
                      X
                    </button>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </>
    );
  }
  const updateQuantityChangeHandle = (e, cartIndex) => {
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;
    cartCopy[cartIndex].quantity = +e.target.value;
    cartCopy[cartIndex].totalPrice = +e.target.value * price;

    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
    // setValue((value) => ++value);
  };

  const handleVariationChange = (value, prod) => {
    changeVariationClass({
      active: true,
    });

    const tempCart = {
      productId: prod.id,
      product: prod,
      quantity: null,
      price: parseInt(value.value),
      salePrice: parseInt(value.sale_price),
      totalPrice: null,
      product_variation: value.name,
    };

    setVarId(tempCart);

    // remove any existing selection for this product, then add the new one
    setSelectedVariableProducts((prev) => [
      ...prev.filter((x) => x.productId !== prod.id),
      tempCart,
    ]);
  };

  const gotoCartHandler = () => {
    GAEventsTracker("View cart", `${window.location.hostname}/cart`);
    Router.push("/cart");
  };
  const gotoHome = () => {
    Router.push("/");
  }

  const addCouponToCart = async (value, resProduct) => {
    const prevCart = [...productCart];

    let productCoupon = null;
    (resProduct ?? []).map((resProd) => {
      return (productCoupon = { ...resProd, price: value });
    });

    const prodInCartIndex = prevCart.findIndex(
      (cart) => cart.product.id === productCoupon.id,
    );
    if (prodInCartIndex >= 0) {
      const prodInCart = prevCart[prodInCartIndex];
      const newTotalPrice = +prodInCart.quantity * +prodInCart.totalPrice;
      const newQuantity = prodInCart.quantity;
      prevCart[prodInCartIndex] = {
        product: productCoupon,
        quantity: newQuantity + 1,
        price: value,
        salePrice: null,
        totalPrice: +prodInCart.totalPrice + newTotalPrice,
      };
    } else {
      prevCart.push({
        product: productCoupon,
        quantity: 1,
        price: value,
        salePrice: null,
        totalPrice: parseInt(value),
      });
    }

    setProductCart(prevCart);
    dispatch(addToCart(prevCart));
    dispatch(setTotalPrice());
    setTimeout(() => {
      NotificationManager.success("Added to cart successfully", "", 3000);
    }, 500);

    // setValue((value) => ++value);
  };

  const gotoCheckoutHandler = () => {
    const storedDeliveryType = localStorage.getItem("Deliverytype");
    const storeDelivery = JSON.parse(storedDeliveryType);
    Router.push("/checkout");
    // if (storeDelivery === "pickup") {
    //   if (orderTimeState === false) {
    //     $("#storeClosed").modal("show");
    //     return;
    //   } else {
    //     setOrderingTime(true);
    //     return;
    //   }
    // } else if (storeDelivery === "delivery") {
    //   if (deliveryOrderTimeState === false) {
    //     $("#storeClosed").modal("show");
    //     return;
    //   } else {
    //     setOrderingTime(true);
    //     return;
    //   }
    // }
    // if (closedHour === "true") {
    //   $("#storeClosed").modal("show");
    //   // NotificationManager.error(`Sorry, You can only order between ${timeOne}AM and ${timeTwo}PM`, '', 6000);
    // } else if (closedHour == "false") {
    //   Router.push("/checkout");
    // }
  };

  const scrollTopHandler = () => {
    if (typeof window !== "undefined" && typeof $ !== "undefined"){
       window.$ = $;
    $(window).ready(function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });

    }
   
  };

  
  const scrollToProduct = (prod) => {
    const prodTab = document.getElementById(prod.product);

    if (!prodTab) {
      console.warn(`Element with ID '${prod.product}' not found.`);
      return; // Exit early to avoid error
    }

    const itemHeight = prodTab.offsetTop;

    window.scroll({
      top: itemHeight,
      left: 0,
      behavior: "smooth",
    });

    setShowSearchBar(false);
  };

  useEffect(() => {
    const selectedPlace = JSON.parse(localStorage.getItem("selectedPlace"));
    const selectedRestaurant = JSON.parse(
      localStorage.getItem("selectedRestaurantName"),
    );
    setPlace(selectedPlace);
    setSelectedRestaurantName(selectedRestaurant);
  }, []);

  useEffect(() => {
    // Set timeout for 3 seconds
    const timer = setTimeout(() => {
      const storedDeliveryType = localStorage.getItem("Deliverytype");
      const storeDelivery = JSON.parse(storedDeliveryType);
      setDeliveryType(storeDelivery);
      // Use jQuery to trigger the modal
      if (restaurantStatus === 0 && restaurantDeleted === 0) {
        document.getElementById("unavailable-modal").click();
      }
      if (deliveryActive === false && storeDelivery === "delivery") {
        document.getElementById("unavailable-modal").click();
      }
      if (pickupActive === false && storeDelivery === "pickup") {
        document.getElementById("unavailable-modal").click();
      }
    }, 1000);

    // Cleanup the timer
    return () => clearTimeout(timer);
  }, [
    restaurantStatus,
    restaurantDeleted,
    deliveryActive,
    pickupActive,
    deliveryType,
  ]);
  const backToHome = () => {
    localStorage.removeItem("cached closest_restaurant");
    localStorage.removeItem("cached other_restaurant");
    localStorage.removeItem("delivery_tracer");
    localStorage.removeItem("addressData");
    localStorage.removeItem("Deliverytype");

    Router.push("/");
  };
  const switchToPickup = () => {
    localStorage.setItem("Deliverytype", JSON.stringify("pickup"));
  };
  const switchToDelivery = () => {
    localStorage.setItem("Deliverytype", JSON.stringify("delivery"));
  };

const [collapsedCategories, setCollapsedCategories] = useState({});

const toggleCategory = (categoryId) => {
  setCollapsedCategories((prev) => ({
    ...prev,
    [categoryId]: !prev[categoryId],
  }));
};
// shared quantity selector

  return (
    <>
      <Layout>
        <Head>
         <link rel="canonical" href={canonicalUrl} />
          <title>Kilimanjaro restaurant</title>
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
          />
           <script
    src="https://code.jquery.com/jquery-3.4.1.min.js"
    integrity="sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo="
    crossOrigin="anonymous"
  />
          <meta
            name="description"
            content="Our Menu: Swallows and Soups: Eba, Semovita, Okro; Pastries: Burger Chicken, Burger Beef, Meat Pie, Chicken Pie; Main Dish: Fried Rice, Coconut Rice, Native Rice; Sides: Salad, Moi-Moi, Plaintains.Our menu offers a wide variety of Nigerian dishes, with categories including Swallows, Soups, Pastries, Rice, Beef, and Chicken. Discover the delicious options available and tantalize your taste buds.
            "
          />

          <meta name="keyword" content="MEALS FOOD RESTAURANT NIGERIA" />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Restaurant",
                name: restautantName.restaurant,
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "23 Nzimiro street, Old GRA. Port Harcourt",
                  addressLocality: "Port Harcourt",
                  addressRegion: "Rivers",
                  addressCountry: "Nigeria",
                },
                telephone: "0700 5454 3663",
                servesCuisine: "Nigerian",
                openingHours: "Mondays - Sundays 03:00a.m - 8:00pm",
              }),
            }}
          />
        </Head>
        <h1 className="visually-hidden">
          Kilimanjaro Restaurant{restautantName.restaurant}
        </h1>

        {loadingState && inlineLoading === 1 && (
          <section className="topLoader">
            <div className="topLoader-container">
              {loadingState && inlineLoading === 1 && <InlineLoading />}
            </div>
          </section>
        )}
        <section
          id="category-top"
          className={`select-restaurant ${
            !restaurantCategories?.length > 0
              ? "active-select-restaurant"
              : null
          }`}
        >
          <div className="container ">
          <h2>Menu List</h2>
          <p>Jollof, native soups, grills and more, made fresh daily across Nigeria. Order for delivery, pickup or dine in.</p>
            <div className="row pt-3">
            <div className="col-12 col-md-6"> {
                    place && (<div className="py-md-2">
                    <p className="mb-2 mb-md-2 mb-lg-0 location-text font-weight-light ">
                      {place}
                    </p>
                  </div>)
                  }</div>
                   <div className="col-12 col-md-4">
                    <div className="py-md-2">
                    <p className="mb-2 mb-md-2 mb-lg-0 location-text font-weight-light ">
                      {selectedRestaurantName}
                    </p>
                  </div>
                </div>
              
               
              <div className="col-12 col-md-2">
                <div className="d-flex  align-items-center flex-wrap">
            

                  <div className="py-md-2">
                    {showCartVisibility && (
                      <a
                        className="ml-md-5 mt-md-0 mt-3 position-relative"
                        onClick={toggleCart}
                      >
                        <img
                          src="/images/icon/shopping-cart-icon-red.svg"
                          alt="cart-logo"
                          width={40}
                          height={35}
                          style={{ cursor: "pointer" }}
                        />
                        <span className="cart-badge-red">{allCart.length}</span>
                      </a>
                    )}
                  </div>

                  {showCart && (
                    <section>
                      <div className="cart-dropdown p-3  bg-white border rounded shadow-sm">
                        <div className="d-flex justify-content-between align-items-center mb-2 border-bottom">
                          <h6 className="m-2 text-center flex-grow-1">Cart</h6>
                          <span
                            className="close text-muted mb-2"
                            style={{ cursor: "pointer", fontSize: "2.5rem" }}
                            onClick={() => setShowCart(false)}
                          >
                            &times;
                          </span>
                        </div>

                        <div className="cart-items-wrapper ">
                          {!allCart.length > 0 ||
                            (allTotalPrice < minOrderAmount && (
                              <p className="mb-2">
                                A minimum order of ₦
                                {minOrderAmount.toLocaleString()} is required
                                before checking out. Current cart's total is: ₦
                                {allTotalPrice === null
                                  ? "0"
                                  : allTotalPrice.toLocaleString()}
                              </p>
                            ))}
                          {allCart.length > 0 ? (
                            <>
                              {allCart.map((cart, index) => {
                                return (
                                  <div
                                    className="cart-items mb-3 w-100"
                                    key={`Prod-cart${cart?.product.id || index}`}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <div className="d-flex">
                                        <img
                                          src={cart.product?.image_url}
                                          alt={cart.product.product}
                                          className="mr-3"
                                          width={30}
                                          height={30}
                                        />
                                        <p className="">
                                          {cart?.product?.product}
                                        </p>
                                      </div>
                                      <p className="">
                                        {"₦" +
                                          cart?.totalPrice?.toLocaleString()}
                                      </p>
                                    </div>

                                    <div className="d-flex justify-content-between mt-2">
                                      <div>
                                        <span
                                          className="increment mr-3"
                                          onClick={() =>
                                            updateQuantityHandle(
                                              index,
                                              "decrement",
                                            )
                                          }
                                        >
                                          –
                                        </span>
                                        <span className="font-weight-bold mr-3">
                                          {cart.quantity}
                                        </span>
                                        <span
                                          className="increment"
                                          onClick={() =>
                                            updateQuantityHandle(
                                              index,
                                              "increment",
                                            )
                                          }
                                        >
                                          ＋
                                        </span>
                                      </div>
                                      <a>
                                        {" "}
                                        <i
                                          className="fa fa-trash"
                                          style={{
                                            color: "#DC042A",
                                            fontSize: "20px",
                                          }}
                                          onClick={() =>
                                            deleteProductCartHandler(
                                              index,
                                              cart.product.id,
                                            )
                                          }
                                        ></i>
                                      </a>
                                    </div>
                                  </div>
                                );
                              })}
                              <div className="d-flex justify-content-between mb-3">
                                <p className="font-weight-bold">Subtotal</p>
                                <p className="h4 font-weight-bold mr-0">
                                  {" "}
                                  {"₦" +
                                    new Intl.NumberFormat().format(totalSum)}
                                </p>
                              </div>

                              <div className="d-flex flex-md-row flex-column justify-content-between">
                                <button
                                  className="btn w-100 mb-2 mb-md-0 mr-md-2"
                                  onClick={() => {
                                    setShowCart(false);
                                    Router.push("/cart");
                                  }}
                                >
                                  <span
                                    className="text"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    View or Edit
                                  </span>
                                </button>

                                <button
                                  className="btn w-100 w-md-auto"
                                  onClick={() => {
                                    setShowCart(false);
                                    Router.push("/checkout");
                                  }}
                                  disabled={allTotalPrice < minOrderAmount}
                                >
                                  <span
                                    className="text"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Proceed to Checkout
                                  </span>
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <p className="empty-text font-weight-normal mb-3 mt-4 text-center">
                                Your cart is empty
                              </p>
                              <button
                                className="btn w-100 w-md-auto"
                                onClick={() => {
                                  setShowCart(false);
                                  Router.push("/");
                                }}
                              >
                                <span
                                  className="text"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Continue shopping
                                </span>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </section>
                  )}

                  {loadingState && inlineLoading === 0 ? (
                    <form className="select-state w-100 mt-1">
                      <div className="inline-loading-css-menu-page">
                        <InlineLoading />
                      </div>
                    </form>
                  ) : null}
                </div>
             
              </div>
              <div className="col-12 col-md-4">
                <form className="select-state mr-0 py-md-2">
                    <div className="search-container">
                      <input
                        value={searchvalue}
                        onChange={handleSearch}
                        // onChange={(e) => setSearchValue(e.target.value)}
                        type="text"
                        placeholder="Search for a meal"
                      />
                      <ul
                        className={showSearchBar ? "results active" : "results"}
                      >
                        {dbValue.map((serachRes) => {
                          return (
                            <li
                              onClick={() => scrollToProduct(serachRes)}
                              key={`SEARCH-RESULT${serachRes.id}`}
                              className="result"
                            >
                              {serachRes.product}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                   
                  </form>
              </div>
                 
            </div>

            <ul className="product-cat">
                  {restaurantCategories?.map((productCategory) => {
                    return (
                      <a
                        onClick={() => {
                          categoryListHandler(productCategory?.category);
                        }}
                        key={`Prod-Category${productCategory?.id}`}
                      >
                        <li
                          className={
                            categoryActiveName === productCategory?.category
                              ? "product-cat-list active"
                              : "product-cat-list"
                          }
                        >
                          {productCategory?.category}
                        </li>
                      </a>
                    );
                  })}
                </ul>
          </div>
        </section>
        <section className="products">
          <div className="container">
            <div className="">
              {!restaurantCategories?.length > 0 ? (
                <div className="">
                  <p>Sorry, there are no menu available for this restaurant.</p>
                </div>
              ) : (
                <div className="">
                {restaurantCategories?.map((restaurantCategory, index) => {
  const allProductsUnavailable =
    restaurantCategory?.category_products?.every((prod) => !prod.status);

  // Skip categories where every product is unavailable
  if (allProductsUnavailable) return null;

  const categoryId = restaurantCategory?.id || `category-${index}`;
  const isCollapsed = !!collapsedCategories[categoryId];

  return (
    <div key={`Res-Category${categoryId}`} className="menu-category">
      <h4
        id={restaurantCategory?.category}
        className={`category-header ${index === 0 ? "first" : ""}`}
      >
        <button
          type="button"
          className="category-toggle"
          onClick={() => toggleCategory(categoryId)}
          aria-expanded={!isCollapsed}
          aria-controls={`products-${categoryId}`}
        >
          <span>{restaurantCategory?.category}</span>

          <i
            className={`fa ${
              isCollapsed ? "fa-chevron-up" : "fa-chevron-down"
            } category-chevron`}
            aria-hidden="true"
          />
        </button>
      </h4>

      {!isCollapsed && (
        <div className="row" id={`products-${categoryId}`}>
          {restaurantCategory?.category_products
            .slice()
            .sort((a, b) =>
              a.status === b.status ? 0 : a.status ? -1 : 1
            )
            .map((prod) => {
                              let variations = [];
                              let variationName = null;
                              let variablePrice = null;
                              if (
                                prod.product_type === "variable" &&
                                prod.product_variations.length > 0
                              ) {
                                variations =
                                  prod.product_variations[0].decodedVariations;
                                variationName =
                                  prod.product_variations[0].variable_name;
                                variations = variations?.map((v) => {
                                  variablePrice = v.sale_price || v.price;
                                  return {
                                    ...v,
                                    value: variablePrice,
                                    label:
                                      v.name +
                                      " — " +
                                      "₦" +
                                      new Intl.NumberFormat().format(
                                        variablePrice,
                                      ),
                                  };
                                });
                              }
                              const newVarBtn =
                                addVariationClass.active &&
                                varId.productId === prod.id
                                  ? "btn"
                                  : "btn disabled";

                              let productPrices = prod.sale_price ? (
                                <h6 className="amount">
                                  <s>{`₦${new Intl.NumberFormat().format(
                                    prod.price,
                                  )}`}</s>
                                </h6>
                              ) : (
                                <h6 className="amount">{`₦${new Intl.NumberFormat().format(
                                  prod.price,
                                )}`}</h6>
                              );
                              let productSalePrice =
                                prod.sale_price === null ? null : (
                                  <h6 className="amount sale">
                                    {"₦" +
                                      new Intl.NumberFormat().format(
                                        prod.sale_price,
                                      )}
                                  </h6>
                                );
                                 const currentQty = quantitiesArray.find((q) => q.productId === prod.id)?.quantity ?? 1;
  const inCart = allCart.some((item) => item.product.id === prod.id);
  const cartIndex = allCart.findIndex((item) => item.product.id === prod.id);


                             
                              const quantitySelector = (
  <QuantitySelector
    prodId={prod.id}
    quantity={currentQty}
    inCart={inCart}
    onDelete={() => deleteProductCartHandler(cartIndex, prod.id)}
    onQuantityChange={handleQuantityChange} 
    onCartQuantityChange={handleCartQuantityChange}
  />
);

// "Added to Cart" indicator or "Add to Cart" button
const addedIndicator = inCart ? (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "5px",
      color: "#E1686D",
      fontWeight: "600",
      fontSize: "14px",
    }}
  >
    <span style={{ fontSize: "20px" }}>✓</span> Added to Cart
  </span>
) : null;

let btn = (
  <>
    {!inCart && (
      <button
        onClick={() => addtoCartHandler(prod)}
        disabled={!prod.status || inlineLoading === prod.id}
        className="btn"
      >
        <span className="text">
          {!prod.status
            ? "Out of Stock"
            : inlineLoading === prod.id
            ? "Adding..."
            : "Add to Cart"}
        </span>
      </button>
    )}
    {inCart && addedIndicator}
  </>
);

if (prod.product_type === "variable") {
  productPrices = null;
  productSalePrice = null;
  btn = (
    <>
      {!inCart && (
        <button
          onClick={() => addtoCartHandler(prod)}
          className={newVarBtn}
          disabled={!prod.status || inlineLoading === prod.id}
        >
          <span className="text">
            {!prod.status
              ? "Out of Stock"
              : inlineLoading === prod.id
              ? "Adding..."
              : "Add to Cart"}
          </span>
        </button>
      )}
      {inCart && addedIndicator}
    </>
  );
}
                              return (
                                <>
                                 <div
            key={`Product-Id${prod.id}`}
            className="col-12 col-md-4 col-lg-4 mb-4"
          >
            <div
  id={prod.product}
  key={`Product-Id${prod.id}`}
  className="single-product"
  style={{ opacity: !prod.status ? 0.7 : 1 }}
>

  <div className="product-image-container">
  <a
    className="product-image-link"
    style={{
      pointerEvents: !prod.status ? "none" : "auto",
    }}
    href={`/product/${prod.slug}`}
  >
    <LazyLoadImage
      className="img-fluid product-image"
      src={prod.image_url}
      alt={prod.product}
      wrapperClassName="placeholder-class"
      placeholderSrc="/images/favicon/apple-touch-icon.png"
    />
  </a>
</div>

  <div className="product-details">
    <div className="product-heading">
      <a
        className="product-name text-dark"
        style={{
          textDecoration: "none",
          pointerEvents: !prod.status ? "none" : "auto",
        }}
        href={`/product/${prod.slug}`}
      >
        {prod.product}
      </a>

      <div className="product-quantity">
        {quantitySelector}
      </div>
    </div>

    <p className="product-description">
      {prod.short_description}
    </p>

    {prod.product_type === "variable" && (
      <>
        <form className="select-state mt-3">
          <Select
            onChange={(e) => handleVariationChange(e, prod)}
            className="select-tool w-100 variation"
            options={variations}
            placeholder={`Choose a ${variationName}`}
            instanceId={`productVariations-${prod.id}`}
          />
        </form>

        <div className="product-footer mt-3">
          {loadingState && inlineLoading === prod.id ? (
            <InlineLoading />
          ) : (
            btn
          )}

          <div>
            {productPrices}
            {productSalePrice}
          </div>
        </div>
      </>
    )}

    {prod.product_type === "simple" && (
      <div className="product-footer mt-3">
        {loadingState && inlineLoading === prod.id ? (
          <InlineLoading />
        ) : (
          btn
        )}

        <div>
          {productPrices}
          {productSalePrice}
        </div>
      </div>
    )}
  </div>
</div>
          </div>
                                  

                                </>
                              );
                            })}
        </div>
      )}
    </div>
  );
})}
                  {/* {restaurantCategories?.map((restaurantCategory, index) => {
                    // Check if all products in the category are unavailable
                    const allProductsUnavailable =
                      restaurantCategory?.category_products.every(
                        (prod) => !prod.status,
                      );

                    // If all products are unavailable, skip rendering this category
                    if (allProductsUnavailable) return null;

                    return (
                      <>
                        <div
                          key={`Res-Category${restaurantCategory?.id || index}`}
                        >
                          <h4
                            id={restaurantCategory?.category}
                            className={`category-header ${
                              index === 0 ? "first" : ""
                            }`}
                          >
                            {restaurantCategory?.category}
                          </h4>
                          <div className="row">
                             {restaurantCategory?.category_products
                            .slice() // Create a shallow copy to avoid mutating the original array
                            .sort((a, b) =>
                              a.status === b.status ? 0 : a.status ? -1 : 1,
                            )
                            .map((prod) => {
                              let variations = [];
                              let variationName = null;
                              let variablePrice = null;
                              if (
                                prod.product_type === "variable" &&
                                prod.product_variations.length > 0
                              ) {
                                variations =
                                  prod.product_variations[0].decodedVariations;
                                variationName =
                                  prod.product_variations[0].variable_name;
                                variations = variations?.map((v) => {
                                  variablePrice = v.sale_price || v.price;
                                  return {
                                    ...v,
                                    value: variablePrice,
                                    label:
                                      v.name +
                                      " — " +
                                      "₦" +
                                      new Intl.NumberFormat().format(
                                        variablePrice,
                                      ),
                                  };
                                });
                              }
                              const newVarBtn =
                                addVariationClass.active &&
                                varId.productId === prod.id
                                  ? "btn"
                                  : "btn disabled";

                              let productPrices = prod.sale_price ? (
                                <h6 className="amount">
                                  <s>{`₦${new Intl.NumberFormat().format(
                                    prod.price,
                                  )}`}</s>
                                </h6>
                              ) : (
                                <h6 className="amount">{`₦${new Intl.NumberFormat().format(
                                  prod.price,
                                )}`}</h6>
                              );
                              let productSalePrice =
                                prod.sale_price === null ? null : (
                                  <h6 className="amount sale">
                                    {"₦" +
                                      new Intl.NumberFormat().format(
                                        prod.sale_price,
                                      )}
                                  </h6>
                                );
                                 const currentQty = quantitiesArray.find((q) => q.productId === prod.id)?.quantity ?? 1;
  const inCart = allCart.some((item) => item.product.id === prod.id);
  const cartIndex = allCart.findIndex((item) => item.product.id === prod.id);


                             
                              const quantitySelector = (
  <QuantitySelector
    prodId={prod.id}
    quantity={currentQty}
    inCart={inCart}
    onDelete={() => deleteProductCartHandler(cartIndex, prod.id)}
    onQuantityChange={handleQuantityChange} 
    onCartQuantityChange={handleCartQuantityChange}
  />
);

// "Added to Cart" indicator or "Add to Cart" button
const addedIndicator = inCart ? (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "5px",
      color: "#E1686D",
      fontWeight: "600",
      fontSize: "14px",
    }}
  >
    <span style={{ fontSize: "20px" }}>✓</span> Added to Cart
  </span>
) : null;

let btn = (
  <>
    {!inCart && (
      <button
        onClick={() => addtoCartHandler(prod)}
        disabled={!prod.status || inlineLoading === prod.id}
        className="btn"
      >
        <span className="text">
          {!prod.status
            ? "Out of Stock"
            : inlineLoading === prod.id
            ? "Adding..."
            : "Add to Cart"}
        </span>
      </button>
    )}
    {inCart && addedIndicator}
  </>
);

if (prod.product_type === "variable") {
  productPrices = null;
  productSalePrice = null;
  btn = (
    <>
      {!inCart && (
        <button
          onClick={() => addtoCartHandler(prod)}
          className={newVarBtn}
          disabled={!prod.status || inlineLoading === prod.id}
        >
          <span className="text">
            {!prod.status
              ? "Out of Stock"
              : inlineLoading === prod.id
              ? "Adding..."
              : "Add to Cart"}
          </span>
        </button>
      )}
      {inCart && addedIndicator}
    </>
  );
}
                              return (
                                <>
                                 <div
            key={`Product-Id${prod.id}`}
            className="col-12 col-md-4 col-lg-4 mb-4"
          >
            <div
  id={prod.product}
  key={`Product-Id${prod.id}`}
  className="single-product"
  style={{ opacity: !prod.status ? 0.7 : 1 }}
>

  <div className="product-image-container">
  <a
    className="product-image-link"
    style={{
      pointerEvents: !prod.status ? "none" : "auto",
    }}
    href={`/product/${prod.slug}`}
  >
    <LazyLoadImage
      className="img-fluid product-image"
      src={prod.image_url}
      alt={prod.product}
      wrapperClassName="placeholder-class"
      placeholderSrc="/images/favicon/apple-touch-icon.png"
    />
  </a>
</div>

  <div className="product-details">
    <div className="product-heading">
      <a
        className="product-name text-dark"
        style={{
          textDecoration: "none",
          pointerEvents: !prod.status ? "none" : "auto",
        }}
        href={`/product/${prod.slug}`}
      >
        {prod.product}
      </a>

      <div className="product-quantity">
        {quantitySelector}
      </div>
    </div>

    <p className="product-description">
      {prod.short_description}
    </p>

    {prod.product_type === "variable" && (
      <>
        <form className="select-state mt-3">
          <Select
            onChange={(e) => handleVariationChange(e, prod)}
            className="select-tool w-100 variation"
            options={variations}
            placeholder={`Choose a ${variationName}`}
            instanceId={`productVariations-${prod.id}`}
          />
        </form>

        <div className="product-footer mt-3">
          {loadingState && inlineLoading === prod.id ? (
            <InlineLoading />
          ) : (
            btn
          )}

          <div>
            {productPrices}
            {productSalePrice}
          </div>
        </div>
      </>
    )}

    {prod.product_type === "simple" && (
      <div className="product-footer mt-3">
        {loadingState && inlineLoading === prod.id ? (
          <InlineLoading />
        ) : (
          btn
        )}

        <div>
          {productPrices}
          {productSalePrice}
        </div>
      </div>
    )}
  </div>
</div>
          </div>
                                  

                                </>
                              );
                            })}
                          </div>
                         
                        </div>
                      </>
                    );
                  })} */}
                </div>
              )}
            </div>
          </div>
          <div></div>

          <button
            type="button"
            className="btn btn-primary "
            data-toggle="modal"
            data-target="#orderTypeModal"
            id="order-type-modal"
            style={{ display: "none" }}
          >
            Launch demo modal
          </button>
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            id="orderTypeModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="orderTypeModalLabel"
            data-backdrop="static"
            aria-hidden={!showModal}
            data-keyboard="false"
            style={{ display: showModal ? "block" : "none" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-4">
                <span
                  data-dismiss="modal"
                  aria-label="Close"
                  id="closeOrderTypeModal"
                  style={{
                    marginLeft: "auto",
                    fontSize: "15px",
                    color: "white",

                    display: "none",
                  }}
                  className="px-4"
                >
                  <a>
                    <img src="/images/x.svg" />
                  </a>
                </span>

                <div className="modal-body">
                  <p className=" text-center">
                    How would you like to complete your order?
                  </p>
                  <div className="row mt-3">
                    {/* Paystack Option */}
                    <div className="col-md-6 mb-3 ">
                      <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox">
                        {/* Left content */}
                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                          <img
                            src="/images/pick-up.svg"
                            alt="Pickup icon"
                            width={20}
                            height={20}
                          />
                          <p className="ml-1">Pick-up</p>
                        </div>

                        {/* Radio button aligned right */}
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="pickup"
                            name="orderTypeInput"
                            className="form-check-input check radio"
                            onChange={handleOrderTypeChange}
                          />
                        </div>
                      </label>
                    </div>
                    <div className="col-md-6 mb-3 ">
                      <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox">
                        {/* Left content */}
                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                          <img
                            src="/images/truck.svg"
                            alt="delivery"
                            width={20}
                            height={20}
                          />
                          <p className="ml-1">Delivery</p>
                        </div>

                        {/* Radio button aligned right */}
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="delivery"
                            name="orderTypeInput"
                            className="form-check-input check radio"
                            onChange={handleOrderTypeChange}
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                  {locationPicker && (
                    <>
                      <button
                        style={{
                          display: "block",
                          margin: "0 auto",

                          marginBottom: "20px",
                          width: "50%",
                        }}
                        onClick={() => {
                          handleButtonClick();
                        }}
                        className="btn select-tool "
                      >
                        <span className="text">Use My Location</span>
                      </button>
                      <p className="text-center">
                        Enter your address below
                      </p>

                      <div>
                        <GoogleAutoComplete
                          handlePlaceSelect={handlePlaceSelect}
                        />
                      </div>
                      {calculateDistance ? (
                        <p className="text-center mt-2">
                          Calculating distance...
                        </p>
                      ) : (
                        <div>
                          {status === "out of range" && orderType === "delivery" && (
                            <p className="text-center text-danger font-weight-bold mt-1">
                              Location is out of range for delivery, please
                              select another location or you can switch to
                              pick-up!
                            </p>
                          )}
                          {status === "out of range" && orderType === "pickup" && (
                            <p className="text-center text-danger font-weight-bold mt-1">
                              The selected address does not match this restaurant!
                            </p>
                          )}
                          {status === "within range" && orderType === "delivery" && (
                            <p className="text-center text-success font-weight-bold mt-1">
                              Location is within range for delivery, please
                              proceed with your order.
                            </p>
                          )}
                          {status === "within range" && orderType === "pickup" && (
                            <p className="text-center text-success font-weight-bold mt-1">
                              Location set! Please go ahead with your order.
                            </p>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  <section>
                    {status === "out of range" && (
                      <>
                        {Object.keys(restaurantClosest).length > 0 && (
                          <>
                            {" "}
                            <p className="my-2 pt-4">
                              Hang on! We found a restaurant that matches your
                              selected address
                            </p>
                            <div
                              className=" py-5 px-5 mb-5 col-md-12 suggested-restaurant"
                              onClick={() => {
                                handleRestaurantInputChange(restaurantClosest);
                              }}
                            >
                              <div className="d-flex border pr-3 pt-3 suggested-restaurant-inner">
                                <div>
                                  <div className="d-flex gap-2">
                                    {" "}
                                    <img
                                      className="pr-2 img-fluid"
                                      src="/images/pick-up.svg"
                                      alt="pickup icon"
                                      width={50}
                                      height={50}
                                    />
                                    <div
                                      className="mt-2"
                                      key={restaurantClosest?.slug}
                                    >
                                      <h6 className="text-left">
                                        {restaurantClosest?.name}
                                      </h6>
                                      <p className="pb-3 m-0 text-left">
                                        {restaurantClosest?.address}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  key={restaurantClosest?.slug}
                                  className="duration"
                                >
                                  <div className="duration-inner">
                                    <p className="duration-text font-weight-bold">
                                      {restaurantClosest.duration} <br /> Away
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {restaurants.length > 0 && (
                          <>
                            <h6 className=" text-center pt-md-6 pt-lg-6 mb-3">
                              Other restaurants close to you
                            </h6>
                            <div
                              className=" py-5 px-5 mb-5 col-md-12 suggested-restaurant"
                              onClick={() => {
                                handleRestaurantInputChange(
                                  restaurants[0]?.restaurant,
                                );
                              }}
                            >
                              <div className="d-flex border pr-3 pt-3 suggested-restaurant-inner">
                                <div>
                                  <div className="d-flex gap-2">
                                    {" "}
                                    <img
                                      className="pr-2 img-fluid"
                                      src="/images/pick-up.svg"
                                      alt="pick up icon"
                                      width={50}
                                      height={50}
                                    />
                                    <div
                                      className="mt-2"
                                      key={restaurants[0]?.restaurant.slug}
                                    >
                                      <h6 className="text-left">
                                        {restaurants[0]?.restaurant.name}
                                      </h6>
                                      <p className="pb-3 m-0 text-left">
                                        {restaurants[0]?.restaurant.address}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  key={restaurants[0]?.restaurant.slug}
                                  className="duration"
                                >
                                  <div className="duration-inner">
                                    <p className="duration-text font-weight-bold">
                                      {restaurants[0]?.duration} <br /> Away
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </section>

                  <a
                    className="text-center d-block text-danger mt-3"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="closeModal"
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div onClick={scrollTopHandler} className="button-float">
          <i className="fa fa-chevron-up float-arrow"></i>
         
        </div>

        <button
          type="button"
          className="btn btn-primary "
          data-toggle="modal"
          data-target="#exampleModal"
          id="category-status"
          style={{ display: "none" }}
        >
          Launch demo modal
        </button>

        <button
          type="button"
          className="btn btn-primary "
          data-toggle="modal"
          data-target="#exampleModal"
          id="inactive-modal"
          style={{ display: "none" }}
        >
          Launch demo modal
        </button>

        <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{ marginLeft: "auto" }}
              >
                <span
                  aria-hidden="true"
                  className="ms-auto"
                  style={{ fontSize: "24px" }}
                >
                  &times;
                </span>
              </button>

              <div className="modal-body">
                <p
                  className=" text-center"
                  style={{ fontSize: "24px", fontWeight: "bold" }}
                >
                  {text}
                </p>
              </div>
            </div>
          </div>
        </div>
        <section>
          <button
            type="button"
            className="btn btn-primary "
            data-toggle="modal"
            data-target="#unavailableModal"
            id="unavailable-modal"
            style={{ display: "none" }}
          >
            Launch unavailable modal
          </button>

          {/* <div
            className="modal fade "
            id="unavailableModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="unavailableModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered "
              role="document"
            >
              <div className="modal-content  px-5 py-4  unavailable-modal">
                <div className="d-flex align-items-center justify-content-end">
                  <a>
                    <span
                      data-dismiss="modal"
                      aria-label="Close"
                      id="closeReviewModal"
                      role="button"
                    >
                      <img
                        src="/images/x-icon-grey.png"
                        width={15}
                        height={15}
                        alt="close"
                      />
                    </span>
                  </a>
                </div>

                <div className=" modal-body p-0">
                  <h6 className="mb-0 text-center">
                    Restaurant Currently Unavailable
                  </h6>
                  <p className=" text-center mt-1">
                    {deliveryActive === false &&
                    pickupActive === true &&
                    deliveryType === "delivery"
                      ? "Sorry, this restaurant isn't accepting delivery orders right now. You can switch to pickup."
                      : pickupActive === false &&
                          deliveryActive === true &&
                          deliveryType === "pickup"
                        ? "Sorry, this restaurant isn't accepting delivery orders right now. You can switch to delivery."
                        : "Sorry, this restaurant isn't accepting orders right now. Please select another restaurant to continue."}
                  </p>
                  <div className="d-flex justify-content-center">
                    {deliveryActive === false &&
                    pickupActive === true &&
                    deliveryType === "delivery" ? (
                      <button
                        className="btn select-tool mt-4 w-50"
                        onClick={switchToPickup}
                        data-dismiss="modal"
                        aria-label="Close"
                        id="closeReviewModal"
                      >
                        <span className="text">Switch to Pickup</span>
                      </button>
                    ) : deliveryActive === true &&
                      pickupActive === false &&
                      deliveryType === "pickup" ? (
                      <button
                        className="btn select-tool mt-4 w-50"
                        onClick={switchToDelivery}
                        data-dismiss="modal"
                        aria-label="Close"
                        id="closeReviewModal"
                      >
                        <span className="text">Switch to Delivery</span>
                      </button>
                    ) : (
                      <button
                        className="btn select-tool mt-4 w-50"
                        onClick={backToHome}
                        data-dismiss="modal"
                      >
                        <span className="text">Change Location</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}


 <button
            type="button"
            className="btn btn-primary "
            data-toggle="modal"
            data-target="#storeIsClosed"
            id="closed-store-modal"
            style={{ display: "none" }}
          >
            Launch closed store modal
          </button>
           <div className="modal fade" id="storeIsClosed" role="dialog" tabindex="-1"
            
            aria-labelledby="storeIsClosedModalLabel"
            aria-hidden="true">
                <div className="modal-dialog closed-dialog">
                  {/* <!-- Modal content--> */}
                  <div className="modal-content">
                    <div className="modal-header">
                     <button
  type="button"
  className="close"
  data-dismiss="modal"
  aria-label="Close"
>
  <span aria-hidden="true" style={{
      fontSize: "2.5rem",
      fontWeight: "700",
    }}>&times;</span>
</button>
                     
     
                     
                    </div>
                    <div className="modal-body pb-5">
                     <h4 className="modal-title text-center ">Store closed</h4>
                      <div className="restaurants closed-res">
                    


    <p className="text-center mt-1">
      {
        pickupActive === false && deliveryActive === true && deliveryType === "pickup" ? "We are currently closed for pickup, you can switch to delivery." : deliveryActive === false && deliveryType === "delivery" ? "We are currently closed for delivery, you can switch to pickup" :
      deliveryType === "delivery" && pickupActive === true
        ? `We're currently closed for delivery, you can place your orders between ${deliveryOpeningTime} and ${deliveryClosingTime} tomorrow. ${deliveryType === "delivery" && !pickupClosed ? "Or you can switch to pickup" : ""} `
        : 
            deliveryType === "pickup" && deliveryActive === true
          ? `We're currently closed for pickup, you can place your orders between ${openingTime} and ${closingTime} tomorrow. ${deliveryType === "pickup" && !deliveryClosed ? "Or you can switch to delivery." : ""}`
          : "The selected restaurant is closed, please choose another restaurant."}
    </p>

   

    {deliveryType === "delivery" && !pickupClosed && pickupActive === true && (
      <button
        onClick={switchToPickup}
        className="btn btn-order mx-auto mt-3 "
         data-dismiss="modal"
          aria-label="Close"
      >
        <span className="text">Switch to pickup</span>
      </button>
    )}
     { deliveryType === "pickup" && !deliveryClosed && deliveryActive === true && (
      <button
        onClick={switchToDelivery}
        className="btn btn-order mx-auto mt-3 "
         data-dismiss="modal"
          aria-label="Close"
      >
        <span className="text">Switch to delivery</span>
      </button>
    )}
    {
      deliveryType === "pickup" && pickupClosed && !deliveryClosed && pickupActive === true && deliveryActive === true && (<div className="d-flex justify-content-center">
      <button
          className="btn select-tool mt-4  mb-4"
        
          data-dismiss="modal"
          aria-label="Close"
        >
          <span className="text">Order for later</span>
        </button>
    </div>)
     }
     {
      deliveryType === "delivery"   && deliveryClosed && !pickupClosed && deliveryActive === true && pickupActive === true && (<div className="d-flex justify-content-center">
      <button
          className="btn select-tool mt-4  mb-4"
        
          data-dismiss="modal"
          aria-label="Close"
        >
          <span className="text">Order for later</span>
        </button>
    </div>)
     }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </section>
      </Layout>
    </>
  );
};

Menu.getInitialProps = async ({ req, res }) => {
  let selRestaurant = null;
  const isServer = typeof window === "undefined";

  // Cookies.set("selectedRestaurant")

  if (isServer && res) {
    const restaurant = req.cookies.selectedRestaurant;
    selRestaurant = restaurant ? JSON.parse(restaurant) : null;
    
  } else {
    const restaurant = Cookies.get("selectedRestaurant");
    selRestaurant = restaurant ? JSON.parse(restaurant) : null;
    
  }

  let restaurantId = selRestaurant?.id;

  try {
    const {
      data: { data },
    } = await axiosInstance.get(
      `product-categories?restaurant_id=${restaurantId ? restaurantId : 2}`,
    );
    const {
      data: { data: couponData },
    } = await axiosInstance.get(
      `product-coupons?restaurant_id=${restaurantId ? restaurantId : 2}`,
    );
    const {
      data: { data: time },
    } = await axiosInstance.get(`settings/get-order-times`);
    const productCategories = data
      .filter((cat) => cat.category_products.length > 0)
      .map((prodCat) => {
        prodCat["category_products"] = prodCat.category_products.map(
          (catProd) => {
            if (catProd.product_type === "variable") {
              catProd["product_variations"] = catProd.product_variations?.map(
                (pVar) => {
                  const decodedVariations = JSON.parse(pVar.variations);
                  pVar["decodedVariations"] = decodedVariations
                    .map((variation, index) => ({
                      ...variation,
                      status: pVar.variations_statuses[index],
                    }))
                    .filter((variation) => variation.status);
                  return pVar;
                },
              );

              return catProd;
            }
            return catProd;
          },
        );

        return prodCat;
      });
    return { productCategories, couponData, time, restaurantId };
  } catch (error) {
    return { productCategories: null };
  }
};

export default Menu;
